package one.healthium.db.dao

import app.cash.sqldelight.async.coroutines.awaitAsList
import kotlinx.coroutines.Deferred
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import one.healthium.base.coroutines.IO
import one.healthium.db.AppDatabase
import one.healthium.db.FoodEntity

class FoodDao(
    private val db: Deferred<AppDatabase>
) {

    suspend fun getFoods(keyword: String): List<FoodEntity> {
        return withContext(Dispatchers.IO) {
            db.await().foodQueries.selectByKeyword(keyword).awaitAsList()
        }
    }

    suspend fun replaceFoods(entities: List<FoodEntity>) {
        withContext(Dispatchers.IO) {
            val appDatabase = db.await()
            appDatabase.foodQueries.deleteAll()
            appDatabase.transaction {
                entities.forEach {
                    appDatabase.foodQueries.insertFood(
                        product = it.product,
                        emoji = it.emoji,
                        description = it.description,
                        calories = it.calories,
                        protein = it.protein,
                        fat = it.fat,
                        carbohydrates = it.carbohydrates,
                        fiber = it.fiber,
                        tablespoon = it.tablespoon,
                        cups = it.cups,
                        pieces = it.pieces,
                        isLiquid = it.isLiquid,
                    )
                }
            }
        }
    }
}